import React, { useEffect, useState } from 'react';
import { EventDate, SetLoading } from '@arema/components/Classes';
import { Button, Groupper, useFrontier } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import { ReportItem, EventSectionProps } from '../../AdminClasses';
import { SelectDateModal } from '../../components';
import { bindClick } from '@arema/components/Util';
import { useNavigate } from 'react-router-dom';
import API from '../../API';

interface DownloadProps{
	date_start?: number,
	date_end?: number,
	dates: EventDate[],
}

enum Modals{
	SELECT_DATE = 1,
	SELECT_SINGLE_DATE = 2,
}

var EventReports = (props: EventSectionProps)=>{
	var { t } = useTranslation();
	var { Toast } = useFrontier();
	var navigate = useNavigate();
	var [downloading, setDownloading] = useState<boolean>(false);
	var [shownModal, setShownModal] = useState<Modals>(null);
	var [report, setReport] = useState<number>(null);

	const REPORTS : ReportItem<DownloadProps>[] = [{
		title: t('event_reports.date_sales.title'),
		description: t('event_reports.date_sales.description'),
		icon: 'file-pdf',
		ask_date: true,
		onDownload: async p=>{
			var tix = Toast.show('Descargando reporte de ventas...', {
				dismissable: false,
				loading: true,
			});
			try{
				var res = await API.getEventSalesReport(props.event.event_id, p.dates ? p.dates.map(a=>a.date_id) : null);
				if(res.error){
					Toast.error(res.message);
					return null;
				}
				return res.data?.url;
			}catch(e){
				Toast.error(t('common.unexpected_code', { code: 'LCL-EVRPGSLRP-1' }));
			}finally{
				Toast.dismiss(tix);
			}
		}
	}, {
		title: t('event_reports.seatmap.title'),
		description: t('event_reports.seatmap.description'),
		icon: 'map',
		button_text: t('event_reports.seatmap.button'), 
		ask_date: true,
		single_date: true,
		onDownload: async p=>{
			navigate(`/events/${props.event.event_id}/reports/${p.dates[0].date_id}/seats`)
			return null;
		}
	}, {
		title: t('event_reports.pdv_sales.title'),
		description: t('event_reports.pdv_sales.description'),
		icon: "file-csv",
		ask_date: true,
		onDownload: async p=>{
			var tix = Toast.show('Descargando reporte de ventas...', {
				dismissable: false,
				loading: true,
			});
			try{
				var res = await API.getEventPdvSales(props.event.event_id, p.dates ? p.dates.map(a=>a.date_id) : null);
				if(res.error){
					Toast.error(res.message);
					return null;
				}
				return res.data?.url;
			}catch(e){
				Toast.error(t('common.unexpected_code', { code: 'LCL-EVRPPDVSL-1' }));
			}finally{
				Toast.dismiss(tix);
			}
		}
	}, {
		title: t('event_reports.sales_txt.title'),
		description: t('event_reports.sales_txt.description'),
		icon: 'file-text',
		ask_date: true,
		onDownload: async p=>{
			var tix = Toast.show('Descargando reporte de ventas...', {
				dismissable: false,
				loading: true,
			});
			try{
				var res = await API.getEventSalesReport(props.event.event_id, p.dates ? p.dates.map(a=>a.date_id) : null, true);
				if(res.error){
					Toast.error(res.message);
					return null;
				}
				return res.data?.url;
			}catch(e){
				Toast.error(t('common.unexpected_code', { code: 'LCL-EVRPGSLRPTX-1' }));
			}finally{
				Toast.dismiss(tix);
			}
		}
	}, {
		title: t('event_reports.seats_dump.title'),
		description: t('event_reports.seats_dump.description'),
		icon: 'file-text',
		ask_date: true,
		single_date: true,
		onDownload: async p=>{
			var tix = Toast.show('Descargando listado de butacas...', {
				dismissable: false,
				loading: true,
			});
			try{
				var res = await API.getDateSeatDump(p.dates[0].date_id);
				if(res.error){
					Toast.error(res.message);
					return null;
				}
				return res.data?.url;
			}catch(e){
				Toast.error(t('common.unexpected_code', { code: 'LCL-EVRPGSTDMP-1' }));
			}finally{
				Toast.dismiss(tix);
			}
		}
	}];

	var onDateSelected = (dates: EventDate[], setLoading: SetLoading)=>{
		setShownModal(null);
		if(!REPORTS[report]) return;
		var rp = REPORTS[report];
		if(!rp.onDownload) return;
		setDownloading(true);
		setLoading(true);
		rp.onDownload({ dates }).then(url=>{
			setReport(null);
			if(!url) return;
			setTimeout(()=>{
				window.open(url, '_blank');
			});
		}).catch(err=>{
			Toast.error(t('common.unexpected_code', { code: `LCL-EVRP-DWL${report}` }));
		}).finally(()=>{
			setDownloading(false);
			setLoading(false);
		})
	}
	
	return <>
		<Groupper fitted title={t('pdv_reports.title')} style={{ margin: 'auto', maxWidth: 600 }}>
			<div className="ar options">
				{REPORTS.map((a,i)=>(
					<div className="option" key={`RPITM-${i}`}>
						<div className="info">
							<div className="title">{a.title}</div>
							<div className="description">{a.description}</div>
						</div>
						<Button text={a.button_text || t('common.download')} iconName={a.icon} onClick={(setLoading: SetLoading)=>{
							setReport(i);
							if(a.onClick) return a.onClick(setLoading);
							if(a.ask_date){
								return bindClick(setShownModal, a.single_date ? Modals.SELECT_SINGLE_DATE : Modals.SELECT_DATE)();
							}else if(a.ask_date_range){
								// return askEvent(i);
							}
						}} disabled={downloading} />
					</div>
				))}
			</div>
		</Groupper>
		<SelectDateModal
			eventId={props.event.event_id}
			multiple={shownModal!==Modals.SELECT_SINGLE_DATE}
			open={(shownModal===Modals.SELECT_DATE || shownModal===Modals.SELECT_SINGLE_DATE)}
			onClose={bindClick(setShownModal)}
			onSelected={onDateSelected}
		/>
	</>
}

export default EventReports;